import { apiRequest } from '../client';

export async function listBusyDemoSlots({ from, to }) {
  const params = new URLSearchParams();
  params.set('from', from);
  params.set('to', to);
  const result = await apiRequest(`/api/demos/busy?${params.toString()}`);
  return result.busy || [];
}

export async function createDemoBooking(booking) {
  const result = await apiRequest('/api/demos', {
    method: 'POST',
    body: booking,
  });
  return result.id;
}
